import { makeResponsive } from '../../utils';
import styles from './index.module.css';

// Best performing way of checking if an object is empty: https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object#:~:text=250-,Performance,-Today%202020.01.17%2C%20I
const isEmpty = obj => {
  // eslint-disable-next-line
  for (const i in obj) {
    return false;
  }
  return true;
};

/**
 * @typedef {"center" | "flex-end" | "flex-start" | "space-around" | "space-between" | "space-evenly" | "stretch"} alignContent
 * @typedef {"flex-start" | "center" | "flex-end" | "stretch" | "baseline"} alignItems
 * @typedef {"row" | "row-reverse" | "column" | "column-reverse"} flexDirection
 * @typedef {"nowrap" | "wrap" | "wrap-reverse"} flexWrap
 * @typedef {"flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly"} justifyContent
 */

/**
 * @param alignContent {alignContent}
 * @param alignItems {alignItems}
 * @param flexDirection {flexDirection}
 * @param flexWrap {flexWrap}
 * @param justifyContent {justifyContent}
 *
 * @returns - [className, stylesObject]
 *
 * @example
 * const [classnames, stylesObject] = getFlex('center', 'flex-start', 'column', 'no-wrap', 'space-between');
 */

const getFlex = (alignContent, alignItems, flexDirection, flexWrap, justifyContent) => {
  const styleAlignContent = makeResponsive(alignContent, 'align-content');
  const styleAlignItems = makeResponsive(alignItems, 'align-items');
  const styleFlexDirection = makeResponsive(flexDirection, 'flex-direction');
  const styleFlexWrap = makeResponsive(flexWrap, 'flex-wrap');
  const styleJustifyContent = makeResponsive(justifyContent, 'justify-content');

  // Only show the root class when a value is set to one of the flex properties
  const hasNoValues = isEmpty(styleAlignContent) && isEmpty(styleAlignItems) && isEmpty(styleFlexDirection) && isEmpty(styleFlexWrap) && isEmpty(styleJustifyContent);
  return [!hasNoValues && styles.root, {
    ...styleAlignContent,
    ...styleAlignItems,
    ...styleFlexDirection,
    ...styleFlexWrap,
    ...styleJustifyContent
  }];
};
export default getFlex;